//========== Footer Section Component ==========

// import React from "react";
import "./footer.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Footer = () => {
  return /*#__PURE__*/_jsxs("section", {
    className: "footer",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "box-container",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "box",
        children: [/*#__PURE__*/_jsx("h3", {
          children: "Salem's Space Portfolio"
        }), /*#__PURE__*/_jsx("p", {
          children: "Thank you for visiting my personal portfolio website."
        }), /*#__PURE__*/_jsx("p", {
          children: "Connect with me over socials."
        }), /*#__PURE__*/_jsx("p", {
          children: "Keep Rising \uD83D\uDE80. Connect with me over live chat!"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "box",
        children: [/*#__PURE__*/_jsx("h3", {
          children: "Quick Links"
        }), /*#__PURE__*/_jsxs("a", {
          href: "#home",
          children: [/*#__PURE__*/_jsx("i", {
            className: "fas fa-chevron-circle-right"
          }), " Home"]
        }), /*#__PURE__*/_jsxs("a", {
          href: "#about",
          children: [/*#__PURE__*/_jsx("i", {
            className: "fas fa-chevron-circle-right"
          }), " About"]
        }), /*#__PURE__*/_jsxs("a", {
          href: "#services",
          children: [/*#__PURE__*/_jsx("i", {
            className: "fas fa-chevron-circle-right"
          }), " Services"]
        }), /*#__PURE__*/_jsxs("a", {
          href: "#skills",
          children: [/*#__PURE__*/_jsx("i", {
            className: "fas fa-chevron-circle-right"
          }), " Skills"]
        }), /*#__PURE__*/_jsxs("a", {
          href: "#experience",
          children: [/*#__PURE__*/_jsx("i", {
            className: "fas fa-chevron-circle-right"
          }), " Experience"]
        }), /*#__PURE__*/_jsxs("a", {
          href: "#projects",
          children: [/*#__PURE__*/_jsx("i", {
            className: "fas fa-chevron-circle-right"
          }), " Projects"]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "box",
        children: [/*#__PURE__*/_jsx("h3", {
          children: "Contact Info"
        }), /*#__PURE__*/_jsxs("p", {
          children: [/*#__PURE__*/_jsx("i", {
            className: "fas fa-phone"
          }), "+20 155 267 5704"]
        }), /*#__PURE__*/_jsxs("p", {
          children: [/*#__PURE__*/_jsx("i", {
            className: "fas fa-envelope"
          }), "mohamed.salem.dev.official@gmail.com"]
        }), /*#__PURE__*/_jsxs("p", {
          children: [/*#__PURE__*/_jsx("i", {
            className: "fas fa-map-marked-alt"
          }), "Damietta, Egypt"]
        }), /*#__PURE__*/_jsxs("div", {
          className: "share",
          children: [/*#__PURE__*/_jsx("a", {
            className: "linkedin",
            "aria-label": "LinkedIn",
            href: "https://www.linkedin.com/in/mohamed-salem149",
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/_jsx("i", {
              className: "fab fa-linkedin"
            })
          }), /*#__PURE__*/_jsx("a", {
            className: "github",
            "aria-label": "GitHub",
            href: "https://github.com/MoSalem149",
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/_jsx("i", {
              className: "fab fa-github"
            })
          }), /*#__PURE__*/_jsx("a", {
            className: "twitter",
            "aria-label": "Twitter",
            href: "https://twitter.com/MohamedSalem149",
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/_jsx("i", {
              className: "fa-brands fa-x-twitter"
            })
          }), /*#__PURE__*/_jsx("a", {
            className: "telegram",
            "aria-label": "Telegram",
            href: "https://t.me/MoSalem149",
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/_jsx("i", {
              className: "fab fa-telegram-plane"
            })
          }), /*#__PURE__*/_jsx("a", {
            className: "facebook",
            "aria-label": "Facebook",
            href: "https://www.facebook.com/MoSalem149",
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/_jsx("i", {
              className: "fab fa-facebook"
            })
          }), /*#__PURE__*/_jsx("a", {
            className: "email",
            "aria-label": "Email",
            href: "mailto:mohamed.salem.dev.official@gmail.com",
            children: /*#__PURE__*/_jsx("i", {
              className: "fas fa-envelope"
            })
          })]
        })]
      })]
    }), " ", /*#__PURE__*/_jsx("hr", {}), /*#__PURE__*/_jsxs("h1", {
      className: "credit",
      children: ["Designed with ", /*#__PURE__*/_jsx("i", {
        className: "fa fa-heart pulse heart"
      }), " by", " ", /*#__PURE__*/_jsx("a", {
        href: "https://www.linkedin.com/in/mohamed-salem149",
        children: "Mohamed Salem"
      })]
    }), /*#__PURE__*/_jsxs("h2", {
      className: "credit",
      children: [/*#__PURE__*/_jsx("i", {
        className: "fa fa-copyright"
      }), " Copy Right by Salem's Space"]
    })]
  });
};
export default Footer;